import { ReactElement } from 'react';

import {
  Box,
  Divider,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

const DashboardSkeleton = (): ReactElement => {
  return (
    <Stack justifyContent="start" height="100%" gap={3}>
      <Skeleton variant="text" animation="wave" width={500} height={60} />

      <Stack gap={2} direction="row">
        <Skeleton variant="text" animation="wave" width={60} height={34} />
        <Skeleton variant="rounded" animation="wave" width={80} height={34} />
        <Skeleton variant="rounded" animation="wave" width={100} height={34} />
        <Skeleton variant="rounded" animation="wave" width={120} height={34} />
        <Skeleton variant="rounded" animation="wave" width={100} height={34} />
        <Skeleton variant="rounded" animation="wave" width={120} height={34} />
      </Stack>

      <Stack sx={{ backgroundColor: 'white' }} p={3} gap={3}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack direction="row" gap={1} alignItems="center">
            <Skeleton variant="text" animation="wave" width={40} height={40} />
            <Skeleton variant="text" animation="wave" width={150} height={30} />
          </Stack>
          <Stack gap={1} direction="row" alignItems="center">
            <Skeleton variant="text" animation="wave" width={60} height={20} />
            <Skeleton variant="text" animation="wave" width={80} height={20} />
            <Skeleton
              variant="rounded"
              animation="wave"
              width={40}
              height={40}
            />
            <Skeleton
              variant="rounded"
              animation="wave"
              width={40}
              height={40}
            />
          </Stack>
        </Stack>
        <Divider flexItem />
        <Stack direction="row" justifyContent="space-evenly">
          <Skeleton variant="text" animation="wave" width={60} height={20} />
          <Skeleton variant="text" animation="wave" width={120} height={20} />
          <Skeleton variant="text" animation="wave" width={60} height={20} />
          <Skeleton variant="text" animation="wave" width={100} height={20} />
          <Skeleton variant="text" animation="wave" width={80} height={20} />
          <Skeleton variant="text" animation="wave" width={60} height={20} />
          <Skeleton variant="text" animation="wave" width={120} height={20} />
        </Stack>
      </Stack>

      <Paper>
        <Box p={2}>
          <Box mb={4}>
            <Skeleton variant="text" height="30px" />
          </Box>
          <TableContainer
            component={Paper}
            style={{ minHeight: '380px', height: '100%' }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="right">
                    <Skeleton variant="rectangular" />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="rectangular" />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="rectangular" />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="rectangular" />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="rectangular" />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.from({ length: 8 }, (_, i) => i + 1).map((i) => (
                  <TableRow key={i}>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>

      <Box mt={3}>
        <Skeleton variant="rectangular" animation="wave" height={50} />
      </Box>
    </Stack>
  );
};

export default DashboardSkeleton;
